import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { ChecklistSelectorModalComponent } from './checklist-selector-modal.component';
import { PipesModule } from '../../pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, TranslateModule, IonicModule, FormsModule, PipesModule],
  declarations: [ChecklistSelectorModalComponent]
})
export class ChecklistSelectorModalModule {}
